import { Record } from 'immutable';

import {
  RECEIVE_ENTITIES,
  REQUEST_ENTITIES,
  REQUEST_GROUPING_LEVELS,
  RECEIVE_GROUPING_LEVELS
} from './actions';

const State = Record({
  groupingLevels: [],
  groupingLevelsFetching: false,
  entities: [],
  fetchingEntities: false
});

export default (state = new State(), action) => {
  switch (action.type) {
    case REQUEST_GROUPING_LEVELS:
      return state.withMutations(state => {
        state.delete('groupingLevels');
        state.set('groupingLevelsFetching', true);
      });
    case RECEIVE_GROUPING_LEVELS:
      return state.withMutations(state => {
        state.set('groupingLevels', action.data);
        state.set('groupingLevelsFetching', false);
      });

    case REQUEST_ENTITIES:
      return state.withMutations(state => {
        state.delete('entities');
        state.set('fetchingEntities', true);
      });
    case RECEIVE_ENTITIES:
      return state.withMutations(state => {
        state.set('entities', action.data);
        state.set('fetchingEntities', false);
      });

    default:
      return state;
  }
};
